import { useFiles, useManagement, usePage } from 'publisher/store'
import filesSelectors from 'publisher/store/files/filesSelectors'
import managementSelectors from 'publisher/store/management/managementSelectors'
import pageSelectors, {
  getSeoSocialImageFileId,
} from 'publisher/store/page/pageSelectors'
import React from 'react'
import { Helmet } from 'react-helmet'

function MetaTags() {
  const seo = usePage(pageSelectors.getSeo)
  const socialImageFileId = usePage(getSeoSocialImageFileId)
  const url = useManagement(managementSelectors.getUrl)
  const file = useFiles(files =>
    filesSelectors.getFile(files, socialImageFileId),
  )

  const ogImagePath = file ? file.path : ''
  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="title" content={seo.title} />
      <meta name="description" content={seo.description} />
      <meta name="author" content={seo.author} />
      <meta name="keywords" content={seo.keywords} />
      <meta property="og:image" content={ogImagePath} />
      {ogImagePath && <meta property="og:image:alt" content={seo.title} />}
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:url" content={url} />
      {seo.index === false && <meta name="robots" content="noindex" />}
    </Helmet>
  )
}

export default MetaTags
